import React from 'react';
import { useSelector } from 'react-redux';
import { getDateFormat } from '../../utils';
import { getUsCurrencyFormat } from '../../utils/usCurrencyFormatter';
import './SMOrder.scss';

const SMOrder = (props) => {
  const { data: { data: { orderBook = {} } = {} } = {} } = useSelector((state) => state.tradeDetails);

  return (
    <div className='mt-32 smorder'>
      <div className='blocks'>
        {React.Children.toArray(
          props.blocks.map((data) => {
            return (
              <div className='block'>
                <p className='fz-16 mb-4'>{data.label}</p>
                <span className='h3'>
                  {data?.prefix}
                  {getUsCurrencyFormat(Number(orderBook?.[data?.value]) || 0)}
                </span>
              </div>
            );
          })
        )}
      </div>
      {/* <p className='mt-32 subhead-3'>Open orders</p>
      <div className='open'>
        <div className='open__buy'>
          <div className='open__item'>
            <span className='open__item__label'>Buy Price</span>
            <span className='open__item__value'>Quantity</span>
          </div>
          {React.Children.toArray(
            orderBook?.lastBuyOrders?.map((data) => {
              return (
                <div className='open__item'>
                  <span className='open__item__label'>${getUsCurrencyFormat(Number(data.pricePerShare))}</span>
                  <span className='open__item__value'>
                    {data.noOfShares} share{data?.noOfShares > 1 ? 's' : ''}
                  </span>
                </div>
              );
            })
          )}
        </div>
        <hr className='mt-32 mb-32 hr' />
        <div className='open__sell'>
          <div className='open__item'>
            <span className='open__item__label'>Sell Price</span>
            <span className='open__item__value'>Quantity</span>
          </div>
          {React.Children.toArray(
            orderBook?.lastSellOrders?.map((data) => {
              return (
                <div className='open__item'>
                  <span className='open__item__label'>${getUsCurrencyFormat(Number(data.pricePerShare))}</span>
                  <span className='open__item__value'>
                    {data.noOfShares} share{data?.noOfShares > 1 ? 's' : ''}
                  </span>
                </div>
              );
            })
          )}
        </div>
      </div> */}
      <p className='subhead-3 mt-32'>Recently filled orders</p>
      <div className='recent'>
        <div className='recent__item'>
          <span className='recent__item__date'>Date</span>
          <span className='recent__item__price'>Price</span>
          <span className='recent__item__quantity'>Quantity</span>
        </div>
        {React.Children.toArray(
          orderBook?.lastFilledOrders?.map((data) => {
            return (
              <div className='recent__item'>
                <span className='recent__item__date'>
                  {getDateFormat({
                    date: new Date(data?.date),
                    options: {
                      month: 'short',
                      day: 'numeric',
                    },
                  }) || ''}
                </span>
                <span className='recent__item__price'>${getUsCurrencyFormat(Number(data?.pricePerShare) || 0)}</span>
                <span className='recent__item__quantity'>
                  {data?.noOfShares} share{`${data?.noOfShares > 1 ? 's' : ''}`}
                </span>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default SMOrder;
